import { render } from "./groupEdit.vue?vue&type=template&id=7a7816e1&scoped=true"
import script from "./groupEdit.vue?vue&type=script&lang=js"
export * from "./groupEdit.vue?vue&type=script&lang=js"

import "./groupEdit.vue?vue&type=style&index=0&id=7a7816e1&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7816e1"]])

export default __exports__